<template>
  <component :is="to ? Link : 'div'" v-bind="to ? { to, decoration: false } : {}" class="table-row">
    <slot />
  </component>
</template>

<script setup lang="ts">
import { RouteLocationRaw } from 'vue-router';

import Link from '../link.vue';

/** One row of a `Table`: its cells in the table's columns, a hairline above; with `to` the whole row is a link */
defineProps<{ to?: RouteLocationRaw }>();
</script>

<style scoped lang="scss">
.table-row {
  display: grid;
  grid-template-columns: var(--table-columns);
  gap: var(--t-spacing-md);
  align-items: center;
  padding: var(--t-spacing-md) var(--t-spacing-lg);
  border-top: 1px solid var(--t-color-border-secondary);
  color: inherit;
  transition: background-color 150ms var(--t-ease-in-out);

  &:hover {
    background-color: var(--t-color-neutral-50);
  }

  &:focus-visible {
    outline: 2px solid var(--t-color-neutral-950);
    outline-offset: -2px;
  }
}
</style>
